import {useState, type ReactElement} from 'react';
import ArrowIcon from '../../../../assets/img/icons/arrow.svg';
import type {VersionObject} from '../../../../types.d';
import Modal from '../../Modal';
import type {DownloadInstructionsProps} from '../DownloadInstructions/DownloadInstructions';
import DownloadInstructions from '../DownloadInstructions/DownloadInstructions';


export interface HeaderProps {
	header: {
		software: {
			description?: string
			name?: string
			icon: {
				alt: string
				url: string
			}
			type: string
		}
	}
	selectedVersion?: VersionObject | null
	downloadInstructions?: DownloadInstructionsProps
}


export default function Header({
																 downloadInstructions,
																 header: {
																	 software: {
																		 description,
																		 name,
																		 icon: {
																			 alt,
																			 url
																		 },
																		 type
																	 }
																 },
																 selectedVersion,
															 }: HeaderProps) {
	const [showModal, setShowModal] = useState(false);
	const [modalBody, setModalBody] = useState<ReactElement>();

	function handleGetStartedClick() {
		if (!downloadInstructions || !selectedVersion) {
			return;
		}

		setModalBody(
			<DownloadInstructions {...{
				...downloadInstructions,
				initialVersion: selectedVersion,
			}} />,
		);
		setShowModal(true);
	}

	const showAction = type !== 'starter' && Boolean(selectedVersion && downloadInstructions);
	const actionLabel = type === 'application' ? 'Install' : 'Get started…';

	return (
		<>
			<header className="software-show__header">
				<div className="software-show__header__large">
					{url && <img className="software-show__software-icon" src={url} alt={alt}/>}
					{showAction && (
						<button
							type="button"
							className={`software-show__download-button software-show__download-button--${type}`}
							onClick={handleGetStartedClick}
						>
							<ArrowIcon className="software-show__download-button-icon" viewBox="0 0 400 400"/>
							<span>{actionLabel}</span>
						</button>
					)}
					{name && <h1 className="software-show__heading">{name}</h1>}
					{description && <p className="software-show__subtitle">{description}</p>}
				</div>
				<div className="software-show__header__small">
					<div className="software-show__header__small__intro">
						{url && <img className="software-show__software-icon" src={url} alt={alt}/>}
						{name && <h1 className="software-show__heading">{name}</h1>}
					</div>
					<div className="software-show__header__small__info">
						{description && <p className="software-show__subtitle">{description}</p>}
						{showAction && (
							<button
								type="button"
								className={`software-show__download-button software-show__download-button--${type}`}
								onClick={handleGetStartedClick}
							>
								<ArrowIcon className="software-show__download-button-icon" viewBox="0 0 400 400"/>
								<span>{actionLabel}</span>
							</button>
						)}
					</div>
				</div>
			</header>

			<Modal show={showModal} close={() => setShowModal(false)}>{modalBody}</Modal>
		</>
	);
}
